<template>
  <div class="empty-list">
    <v-row>
      <v-col class="d-flex align-center justify-start py-5 empty-list-line">
        <PtrIcon icon="alert-icon" />
        {{ message }}</v-col
      >
    </v-row>
  </div>
</template>

<script>
import PtrIcon from "@/components/shared/PtrIcon";

export default {
  name: "EmptyList",
  components: { PtrIcon },
  props: {
    message: String
  }
};
</script>

<style scoped>
.empty-list {
  padding: 16px;
  background-color: var(--v-primary-lighten5);
  border-radius: 8px;
  color: var(--v-primary-base);
}
.empty-list-line {
  gap: 20px;
  font-size: 13px;
  line-height: 18px;
  font-weight: 700;
}
</style>
